import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { Organization } from "../organization";
import { OpportunityPopulation } from "../opportunity-population";
import { UserPopulation } from "../user-population";
import { UserPopulationPreference } from "../user-population-preference";
import { PopulationEntityConfig } from "./config";
import { PopulationFilters } from "./filters";
import { PopulationMethods } from "./methods";

@HyperEntity("population", PopulationEntityConfig)
export class Population extends extender(PopulationFilters, PopulationMethods) {
    @Fields.id()
    id = "";

    @Fields.string()
    name = "";

    @Fields.string({ dbName: "organization_id" })
    organizationId = "";

    @Relations.toOne<Population, Organization>(
        () => Organization,
        "organizationId",
    )
    organization?: Organization;

    @Relations.toMany(() => OpportunityPopulation, "populationId")
    opportunities: OpportunityPopulation[] = [];

    @Relations.toMany(() => UserPopulation, "populationId")
    userPopulations: UserPopulation[] = [];

    @Relations.toMany(() => UserPopulationPreference, "populationId")
    userPopulationPreferences: UserPopulationPreference[] = [];

    @Fields.string()
    icon = "";

    @Fields.createdAt({ dbName: "created_at" })
    createdAt = new Date();

    @Fields.updatedAt({ dbName: "updated_at" })
    updatedAt = new Date();
}



